import { parseAllowedCountries } from "../lib/api/geo-location";

const REACT_APP_API_URL = '#{{Api_Url}}#';
const ENVIRONMENT = '#{{Environment}}#';
const BUILD_VERSION = '#{{Build.BuildNumber}}#';
const REACT_APP_DIGIO_ACK_EMAIL = '#{{Digio_Ack_Email}}#';
const REACT_APP_ENABLE_CAPTCHA = '#{{Enable_Captcha}}#';
const REACT_APP_ENABLE_PARTNER_CONTRACT = '#{{Enable_Contracts}}#';
const REACT_APP_ENABLE_INTEGRATIONS = '#{{Enable_Integrations}}#';
const REACT_APP_ALLOWED_COUNTRIES = '#{{Allowed_Countries}}#';
const REACT_APP_TALENT_FORUM = '#{{Talent_Forum}}#';

export const devMode = process.env.NODE_ENV === 'development';

export const testAuto = process.env.NODE_ENV === 'test';

export const isCaptchaEnabled = testAuto ? REACT_APP_ENABLE_CAPTCHA : REACT_APP_ENABLE_CAPTCHA;

export const isPartnerContractsEanbled = REACT_APP_ENABLE_PARTNER_CONTRACT;

export const isIntegrationsEnabled = REACT_APP_ENABLE_INTEGRATIONS;

export const isTalentForumEnabled = REACT_APP_TALENT_FORUM;

export const appVersion = `${process.env.REACT_APP_VERSION}${
    BUILD_VERSION.indexOf('Build.BuildNumber') > 0 ? '' : `-${BUILD_VERSION}`
}`;

export const ALLOWED_COUNTRIES = parseAllowedCountries(REACT_APP_ALLOWED_COUNTRIES);


export const serverUrl = devMode ? process.env.REACT_APP_API_URL : REACT_APP_API_URL;
export const apiUrl = '#{{Api_Url}}#';
export const profanityurl = process.env.REACT_APP_PROFANITY_FILTER || '';
export const claimedCandKey = '#{{APIEncryptionKey}}#';
export const hashSecretKey = '#{{HashSecretKey}}#';

export const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const microsoftClientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID || '';
export const linkedInClientId = process.env.REACT_APP_LINKEDIN_CLIENT_ID || '';

export const digioUrl = process.env.REACT_APP_DIGIO_URL || '';
export const digioKYCUrl = process.env.REACT_APP_KYC_DIGIO_URL || '';
export const digioEnv = ENVIRONMENT.indexOf('Environment') > 0 ? 'sandbox' : ENVIRONMENT;
export const digioAckEmail = devMode ? REACT_APP_DIGIO_ACK_EMAIL : REACT_APP_DIGIO_ACK_EMAIL;

export const tinyApiKey = process.env.REACT_APP_TINY_APIKEY || '';

export const uatSiteKey = process.env.REACT_APP_RECAPTCHA_UAT_SITEKEY || '';
export const localSiteKey = process.env.REACT_APP_RECAPTCHA_LOCAL_SITEKEY || '';
export const devSiteKey = process.env.REACT_APP_RECAPTCHA_DEV_SITEKEY || '';
export const liveSiteKey = process.env.REACT_APP_RECAPTCHA_LIVE_SITEKEY || '';
export const testSiteKey = process.env.REACT_APP_RECAPTCHA_TEST_SITEKEY || '';
export const cloudflareSiteKey = process.env.REACT_APP_CLOUDFLARE_SITEKEY || '';
export const locationApiKey = process.env.REACT_APP_LOCATION_API_KEY || '';
export const geoLocationCdnUrl = process.env.REACT_APP_GEO_LOCATION_CDN_URL || '';

export const USER_DATA_CACHE_KEY = '__ox-ud';
export const USER_DATA_IP_ADDRESS_KEY = 'u-ip';
export const USER_DATA_USER_AGENT_KEY = 'u-ua';

export const pluggableBanner = true;
